import { BllOrtak } from './../../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Ortak } from '../../../../providers/ortak';

/**
 * Generated class for the MarkaeklemodalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-markaeklemodal',
  templateUrl: 'markaeklemodal.html',
})
export class MarkaeklemodalPage {
  marka:any={ID:-1,MarkaName:""};
  gidenmarkaadi="";
  constructor(public navCtrl: NavController, 
    public ortak:Ortak,
    public bllOrtak:BllOrtak,
    public viewCtrl:ViewController,
    public navParams: NavParams) {
  }

  ionViewDidLoad() {
   
  }
  boslukKontrol() {
    var mesaj = "";
    
    if (this.marka.MarkName== null || this.marka.MarkName== "") {
      mesaj = mesaj + "Lütfen Marka adını giriniz. <br/>";
    }

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
  kaydet() {

    var formData = new FormData();
   
    if (this.boslukKontrol()) {
      this.gidenmarkaadi=this.marka.MarkName;
      
      formData.append("Marka_Adi",this.gidenmarkaadi);
      formData.append("Marka_json", JSON.stringify(this.marka));
     
      this.bllOrtak.islem(formData, "MarkaEkleGuncelle", "", false).then(a => {
        var sonuc = <any>a;
        if(sonuc.Sonuc==1) this.ortak.showBasicAlert("Başarılı","İşlem Başarılı");
        if(sonuc.Sonuc==0) this.ortak.showBasicAlert("Hata",this.marka.MarkName+"   "+"   "+"adlı marka zaten mevcut");
       

      })
    }
    this.cikis();
    }
    cikis()
    {
      this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/MarkaIslemleri/markaeklemodal/markaeklemodal.ts